import Preact from 'preact';

var FormStructure = {
  fields: {
    headerLabel: {
      validations: []
    },
    SalesRep: {
      validations: []
    },
    firstName: {
      validations: [
        { type: 'required', message: 'Please provide a first name' }
      ]
    },
    lastName: {
      validations: [
        { type: 'required', message: 'Please provide a last name' }
      ]
    },
    telnumber: {
      validations: [
        { type: 'required', message: 'Please provide a phone number' },
        { type: 'regex', pattern: '[(]{0,1}[0-9]{3}[) ]{0,2}[-\s\.]{0,1}[0-9]{3}[-\s\.]{0,1}[0-9]{4}', message: 'Please provide a valid phone number' }
      ]
    },
    email: {
      validations: [
        { type: 'required', message: 'Please provide an email' },
        { type: 'regex', pattern: '[a-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&\'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?', message: 'Please provide a valid email' }
      ]
    },
    Theme: {
      validations: []
    },
    plannedguestcount: {
      validations: []
    },
    EventExtra1: {
      validations: []
    },
    EventExtra2: {
      validations: []
    },
    notes: {
      validations: []
    }
  },
  layout: {
    rows: [
      {
        fields: [
          {
            type: 'label',
            size: 'Medium',
            label: 'Contact Us: Send us a message or call us at 516.331.5077',
            mapping: 'headerLabel',
            customClasses: ['header']
          }
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'Event Planner: Optional',
            options:[
              {label: 'Thomas Reitano', value: 'Thomas Reitano'},
              {label: 'Uliana Ivasivka', value: 'Uliana Ivasivka'},
              {label: 'Leo Fiorillo', value: 'Leo Fiorillo'},
              {label: 'Mitchell Chodes', value: 'Mitchell Chodes'},
              {label: 'Provvi Panarisi', value: 'Provvi Panarisi'},
              {label: 'Kim McCormick', value: 'Kim McCormick'},
              {label: 'Patryk Kuzma', value: 'Patryk Kuzma'},
              {label: 'Helen Tull', value: 'Helen Tull'},
            ],
            mapping: 'SalesRep'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'First Name*',
            mapping: 'firstName'
          },
          {
            type: 'text',
            size: 'Medium',
            label: 'Last Name*',
            mapping: 'lastName'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Phone*',
            mapping: 'telnumber'
      },
      {
            type: 'text',
            size: 'Medium',
            label: 'Email*',
            mapping: 'email'
          },
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Type of Event',
            mapping: 'Theme'
      },
      {
            type: 'text',
            size: 'Medium',
            label: 'Guest Count',
            mapping: 'plannedguestcount'
          }
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'Are you interested in scheduling a tour?',
            options: [
              { label: 'Yes', value: 'Yes' },
              { label: 'No', value: 'No' },
            ],
            mapping: 'EventExtra1'
      },
      {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'How can we help you?',
            options: [
              { label: 'I would like information about a Wedding', value: 'I would like information about a Wedding' },
              { label: 'I would like information about a Social Event', value: 'I would like information about a Social Event' },
              { label: 'I would like information about a Kosher Event', value: 'I would like information about a Kosher Event' },
              { label: 'I would like information about a Corporate Event', value: 'I would like information about a Corporate Event' },
              { label: 'I would like information about a Fire Department Event', value: 'I would like information about a Fire Department Event' },
              { label: 'I would like information about a Healthcare Event', value: 'I would like information about a Healthcare Event' },
              { label: 'I would like information about a Non-Profit Event', value: 'I would like information about a Non-Profit Event' },
              { label: 'I would like information about a Financial Event', value: 'I would like information about a Financial Event' },
              { label: 'I would like information about an Academic Event', value: 'I would like information about an Academic Event' },
              { label: 'I am an existing client', value: 'I am an existing client' },
              { label: 'I would like information about Pool/Tennis Membership', value: 'I would like information about Pool/Tennis Membership' },
              { label: 'Other (please specify in Comments)' , value: 'Other (please specify in Comments)' }
            ],
            mapping: 'EventExtra2'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text-area',
            size: 'XLarge',
            label: 'Comments',
            mapping: 'notes'

          }
        ]
      },
      {
        fields: [
          {
            type: 'submit',
            size: 'XLarge',
            label: 'Contact Us'
          },
        ]
      }
    ]
  },
  info: {
    title: 'Crest Hollow Country Club',
    formId: '723',
    clientKey: 'BC6DF15B-6059-4C94-80F8-7F759D0C884A',
    appKey: '23697F14-AA8C-4622-9F64-FC1A9FF20D0D',
    redirectUrl: '',
    submissionText: 'Thank you! Your web inquiry has been successfully sent. We will contact you very soon!',
    apiEndpoint: '//api-cec.catereasewebtools.com/inbound-inquiries'
  }
};


export default FormStructure;



// WEBPACK FOOTER //
// C:/Users/adrienn.bonnyai/Web-Inquiry/inquiry-renderer/client_forms/cresthollow/form_structure.js